import {useState} from 'react'
import {useNavigate} from 'react-router'
import ApiHelper from '@freckle/school/ts/common/helpers/api-helper'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import Login from '@freckle/school/ts/pages/login/login'

export default function LoginHandler() {
  const [showLogin, setShowLogin] = useState(false)
  const navigate = useNavigate()

  ApiHelper.checkSessionCookies().then(
    () => {
      navigate(Routes.redirectAuthenticated())
    },
    () => {
      setShowLogin(true)
    }
  )

  return showLogin ? <Login /> : <></>
}
